import { z } from 'zod';

export const propertyDataSyncInputSchema = z.object({
  propertyId: z.number(),
});

export const propertyAttributesUpdateSchema = z.object({
  propertyId: z.number(),
  propertyRef: z.string(),
  tenancyId: z.number(),
  /** Determines which tinybase table is synced */
  isPcfra: z.boolean().optional(),
  floorLevel: z.string().optional(),
  adaptation: z.string().optional(),
  heatingType: z.string().optional(),
  accessibleLift: z.string().optional(),
  nextOfKinName: z.string().optional(),
  nextOfKinTelephone: z.string().optional(),
  nextOfKinAddress: z.string().optional(),
});
